import { render, staticRenderFns } from "./Playersladder.vue?vue&type=template&id=9dcc2b5a&scoped=true&"
import script from "./Playersladder.vue?vue&type=script&lang=js&"
export * from "./Playersladder.vue?vue&type=script&lang=js&"
import style0 from "./Playersladder.vue?vue&type=style&index=0&id=9dcc2b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcc2b5a",
  null
  
)

export default component.exports